import { usageIds } from "../constants/usageid.js";
export var AuthenticationSchemaIds;
(function (AuthenticationSchemaIds) {
    AuthenticationSchemaIds["AUTHENTICATION"] = "authentication";
    AuthenticationSchemaIds["UPDATE_SECRET"] = "updateSecret";
    AuthenticationSchemaIds["EMAIL"] = "emailOfInterest";
    AuthenticationSchemaIds["ACCESS_TOKEN"] = "accessToken";
    AuthenticationSchemaIds["GUEST"] = "guest";
})(AuthenticationSchemaIds || (AuthenticationSchemaIds = {}));
export var AuthenticationTags;
(function (AuthenticationTags) {
    AuthenticationTags["DEFAULT"] = "default";
    AuthenticationTags["UPDATE_EMAIL"] = "updateEmail";
    AuthenticationTags["RESET_SECRET"] = "resetSecret";
    AuthenticationTags["RESET_VALIDATION"] = "resetValidation";
})(AuthenticationTags || (AuthenticationTags = {}));
export const AuthenticationTagsMap = {
    [AuthenticationSchemaIds.AUTHENTICATION]: [AuthenticationTags.DEFAULT],
    [AuthenticationSchemaIds.UPDATE_SECRET]: [AuthenticationTags.DEFAULT],
    [AuthenticationSchemaIds.EMAIL]: [AuthenticationTags.UPDATE_EMAIL, AuthenticationTags.RESET_SECRET, AuthenticationTags.RESET_VALIDATION],
};
export const AuthenticationUsageIds = usageIds(AuthenticationTagsMap);
